import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoute = ({ children }) => {
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);

  if (logged) return children;
  return <Navigate to="/" replace />;
};
